module.exports = __webpack_public_path__ + "img/logo.6df792d1.png";